import { useSyncExternalStore, type FC, type ReactNode } from 'react'
import { RelayEnvironmentProvider } from 'react-relay'

import { getRelayEnvironment, subscribeToRelayEnvironment } from '@/lib'

export interface RelayProviderProps {
  children: ReactNode
}

export const RelayProvider: FC<RelayProviderProps> = ({ children }) => {
  // getServerSnapshot is required because this app also renders on web via expo router
  const environment = useSyncExternalStore(subscribeToRelayEnvironment, getRelayEnvironment, getRelayEnvironment)

  return <RelayEnvironmentProvider environment={environment}>{children}</RelayEnvironmentProvider>
}
